import React from 'react';
import * as Render from '../platformui/Base/Render';
import SubjectIntro from '../platformui/SubjectIntro';

export default (props) => (
  <SubjectIntro
    ImgCssClass={'large-7 columns'}
    TextCssClass={'large-5 columns'}
    {...props}
    Heading={Render.Property(props.Heading, 'Heading')}
    Preamble={Render.PropertyAsHTML(props.Preamble, 'Preamble')}
  />
);
